import {KTCard, KTIcon} from '../../../_metronic/helpers'
import WithModal from '../../../components/WithModal'
import StudentsInLiveTrip from '../../../components/studentsInTrip/StudentsInDailyTrip'
import {Badge, Button, Table} from 'react-bootstrap'
import {DailyTripAPIData} from '../../ts/trip'
import TripRoute from './TripRoute'

function TripCard({tripData}: {tripData: DailyTripAPIData}) {
  return (
    <KTCard className="p-6 mb-3">
      <div>
        <div className="text-primary fw-medium fs-5 mb-2">
          {tripData.bus_number} -{' '}
          {tripData.trip_name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      </div>

      <Table bordered>
        <thead>
          <tr>
            <th className="text-gray-600">Start</th>
            <th className="text-gray-600">End</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <div className="d-flex">
                <KTIcon iconName="geolocation" iconType="solid" className="fs-5 mt-1 me-1" />{' '}
                {tripData.start_location}
              </div>
            </td>
            <td>
              <div className="d-flex">
                <KTIcon iconName="geolocation" iconType="solid" className="fs-5 mt-1 me-1" />{' '}
                {tripData.end_location}
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span className="text-muted">
                <KTIcon iconName="time" className="fs-5 mt-1 me-1" /> {tripData.trip_start_time}
              </span>
            </td>
            <td>
              <span className="text-muted">
                <KTIcon iconName="time" className="fs-5 mt-1 me-1" /> {tripData.trip_end_time}
              </span>
            </td>
          </tr>
        </tbody>
      </Table>

      <div className="pt-4 d-flex justify-content-between align-items-center text-gray-700">
        <div>
          <span className="me-1">
            <span className="fw-medium">Driver: </span>
            {tripData.driver_name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}{' '}
          </span>
          <a href={`tel:${tripData.driver_mobile}`} className="inline-block p-0">
            <Badge bg="light-info" className="rounded py-2">
              <i className="fa fa-phone text-success"></i>
            </Badge>
          </a>
        </div>
        <div>
          <WithModal
            renderModalBody={() => <TripRoute tripData={tripData} />}
            modalTitle="Trip Route"
            modalAttrs={{size: 'lg'}}
          >
            <span>
              <i className="fas fa-route me-2"></i>
              Route
            </span>
          </WithModal>

          <WithModal
            renderModalBody={() => <StudentsInLiveTrip dailyTripId={tripData.daily_trip_id} />}
            modalTitle="Students in the Trip"
            modalAttrs={{size: 'xl'}}
          >
            <span className="ms-6 me-2 ">
              <i className="fas fa-users me-2"></i>
              Students in Trip
            </span>
          </WithModal>
        </div>
      </div>
    </KTCard>
  )
}

export default TripCard
